const baseURL = 'https://point.91duobaoyu.com';
const path = '/webtrack/event/newUpload';

export default {
  install (Vue, options) {
    console.log('options', options);
    class StatV2 extends Vue {
      constructor () {
        super();
        this.connection_id = this.generateUUID();
      }

      generateUUID () {
        let uuid = 'xxxxxxxx-xxxx-xxxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
          let r = Math.random() * 16 | 0;
          // eslint-disable-next-line no-mixed-operators
          return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
        return uuid;
      }

      getData (data = {}) {
        const unid = this.generateUUID();
        const {
          // eslint-disable-next-line camelcase
          client_version = '1.0.0',
          user_type,
          getUserId,
          getFsUserId,
          commonExtend = {},
          getCommonExtend = () => ({})
        } = options;
        const {
          preUrl = document.referrer,
          url = window.location.href,
          mobileId = navigator.appName,
          osVersion = navigator.appVersion,
          language = navigator.language,
          clientVersion = client_version
        } = data;
        let _commonExtend = (getCommonExtend && getCommonExtend(unid)) || {};
        if (typeof _commonExtend !== 'object') {
          _commonExtend = {};
        }
        return {
          click_id: unid,
          os_version: osVersion,
          mobile_id: mobileId,
          action_id: data.action_id || null,
          action_type: data.action_type || null,
          button_name: data.button_name || null,
          client_version: clientVersion,
          connection_id: this.connection_id,
          user_id: data.user_id || (getUserId && getUserId()) || null,
          fs_user_id: data.fs_user_id || (getFsUserId && getFsUserId()) || 1,
          utd_id: data.utd_id || null,
          pre_view_id: preUrl || '',
          current_view_id: url || null,
          language,
          resolution_ratio: data.resolution_ratio || null,
          extend: { ...commonExtend, ..._commonExtend, ...(data.extend || {}) },
          arise_time: this.$helper.getTime('YYYY-MM-DD HH:mm:ss'),
          network_type: data.network_type || null,
          latitude: data.latitude || null,
          longitude: data.longitude || null,
          user_type: data.user_type || user_type || 'user_ID',
          client_channel: data.client_channel || null,
          remain_time: data.remain_time || '0',
          component_num: data.component_num || -1,
          position_num: data.position_num || -1,
          time_on_page_type: data.time_on_page_type || 1,
          time_interval: data.time_interval || 0
        };
      }

      send (data = {}) {
        if (!data.action_id) {
          return;
        }
        const json = this.getData(data);
        return this.$request.post({
          path,
          baseURL,
          data: json,
          headerToken: false
        });
      }

      sendBeacon (data = {}) {
        const json = this.getData(data);
        const blob = new Blob([JSON.stringify({
          data: json,
          token: this.$request.token,
          env: this.$env.environment === 'prod' ? 'RELEASE' : this.$env.environment.toLocaleUpperCase()
        })], { type: 'application/x-www-form-urlencoded' });
        if (navigator.sendBeacon) {
          navigator.sendBeacon('http://localhost:8002/buriedpoint/upload', blob);
        } else {
          let xhr = new XMLHttpRequest();
          xhr.open('POST', 'http://localhost:8002/buriedpoint/upload', true);
          xhr.send(blob);
        }
      }
    }
    const statV2 = new StatV2();
    const statDataV2 = {
      bind (el, binding, vnode) {
        const context = vnode.context;
        el.context = context;
        let trigger = binding.value.trigger || ['click'];
        delete binding.value.trigger;
        el.vData = {
          ...binding.value
        };
        trigger = trigger instanceof Array ? trigger : [trigger];
        trigger.forEach(item => {
          let triggerItem = {};
          if (typeof item === 'string') {
            triggerItem = {
              event: item,
              buriedpoint: 'click'
            };
          } else if (typeof item === 'object' && item.event) {
            triggerItem = {
              ...item
            };
          } else {
            return;
          }
          if (triggerItem.event === 'hold') {
            let sto = null;
            const time = binding.value.longTouchTime || 1000;
            if (vnode.componentInstance) {
              vnode.componentInstance.$on('touchstart', () => {
                clearTimeout(sto);
                sto = null;
                sto = setTimeout(() => {
                  statDataV2.sendStatData(el, 'hold');
                }, time);
              });
              vnode.componentInstance.$on('touchend', () => {
                clearTimeout(sto);
                sto = null;
              });
            } else {
              el.addEventListener('touchstart', () => {
                clearTimeout(sto);
                sto = null;
                sto = setTimeout(() => {
                  statDataV2.sendStatData(el, 'hold');
                }, time);
              });
              el.addEventListener('touchend', () => {
                clearTimeout(sto);
                sto = null;
              });
            }
          } else if (triggerItem.listener === 'on') {
            vnode.componentInstance.$on(triggerItem.event, () => {
              statDataV2.sendStatData(el, triggerItem.buriedpoint || 'click');
            });
          } else {
            el.addEventListener(triggerItem.event, () => {
              statDataV2.sendStatData(el, triggerItem.buriedpoint || 'click');
            });
          }
        });
      },
      update (el, binding) {
        delete binding.value.trigger;
        el.vData = {
          ...binding.value
        };
      },
      sendStatData (el, actionType) {
        if (!el.context) return;
        statV2.send({
          action_type: actionType,
          ...el.vData,
          connection_id: el.vData.connection_id || el.context.$request.token || '',
          current_view_id: el.vData.current_view_id || el.context.$route.path
        }).catch(() => {});
      }
    };
    Vue.prototype.$statV2 = statV2;
    Vue.directive('stat-data-v2', statDataV2);
  }
};
